import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Linkedin, Twitter, Facebook } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0A1F44] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-8">
          {/* Company Info */}
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#FF6A00] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">HH</span>
              </div>
              <div>
                <div className="font-bold text-white text-base">
                  {t('nav.brand')}
                </div>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              {t('footer.companyDesc')}
            </p>
            <p className="text-xs text-gray-400">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Our Expertise */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('about.expertise.title')}</h3>
            <ul className="space-y-2">
              {t('about.expertise.items', { returnObjects: true }).map((item, index) => {
                const links = [
                  '/consultancy/wireline-qualification',
                  '/consultancy/wireline-operation',
                  '/consultancy/manufacturing',
                  '/consultancy/ai-technology',
                  '/products',
                  '/resources/manpower'
                ];
                return (
                  <li key={index}>
                    <Link to={links[index] || '/'} className="text-gray-300 hover:text-[#FF6A00] text-sm">
                      {item}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-[#FF6A00] mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  {t('footer.location')}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 text-[#FF6A00] mt-0.5 flex-shrink-0" />
                <a href="mailto:support@hh-enterprise.net" className="text-gray-300 hover:text-[#FF6A00] text-sm">
                  support@hh-enterprise.net
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 text-[#FF6A00] mt-0.5 flex-shrink-0" />
                <a href="tel:+6583064033" className="text-gray-300 hover:text-[#FF6A00] text-sm">
                  +65 8306 4033
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF6A00] transition-all duration-300" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF6A00] transition-all duration-300" aria-label="Twitter">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF6A00] transition-all duration-300" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              {t('footer.rights', { year: currentYear })}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#FF6A00] transition-colors">{t('footer.privacy')}</a>
              <a href="#" className="text-gray-400 hover:text-[#FF6A00] transition-colors">{t('footer.terms')}</a>
              <a href="#" className="text-gray-400 hover:text-[#FF6A00] transition-colors">{t('footer.sitemap')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
